export type ContractStatus = "active" | "expired" | "pending_renewal" | "terminated";

export const statusLabels: Record<ContractStatus, string> = {
  active: "Active",
  expired: "Lapsed",
  pending_renewal: "Decision Pending",
  terminated: "Terminated",
};

export const statusColors: Record<ContractStatus, { bg: string; text: string; dot: string }> = {
  active:          { bg: "bg-secondary-50",    text: "text-secondary-700",   dot: "bg-secondary-500" },
  pending_renewal: { bg: "bg-accent-50",        text: "text-accent-700",      dot: "bg-accent-500" },
  expired:         { bg: "bg-foreground-100",   text: "text-foreground-600",  dot: "bg-foreground-400" },
  terminated:      { bg: "bg-foreground-200",   text: "text-foreground-700",  dot: "bg-foreground-500" },
};
